import { alpha, Box, Paper, Stack, styled, Typography } from '@mui/material'

export const Wrapper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: 'primary' | 'secondary' }>`
  padding: 12px 16px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  background-color: ${({ color, theme }) =>
    color === 'primary'
      ? theme.palette.custom.blue2
      : theme.palette.custom.orange1};
  width: 235px;
  box-shadow: 0 16px 26px 0 rgba(5, 19, 80, 0.07);
`

export const SectionTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.custom.white};
`

export const Divider = styled(Box)`
  height: 1px;
  background-color: ${({ theme }) => alpha(theme.palette.custom.gray8, 0.2)};
`

export const SectionRow = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const RowTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.white};
`

export const RowValue = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.custom.white};
`
